

export const sendUnauthorizedEvent = () => {
  dispatchEvent(new CustomEvent('UNAUTHORIZED_EVENT', {}));
};
